import { render } from "./removeAccount.vue?vue&type=template&id=320516d6&scoped=true"
import script from "./removeAccount.vue?vue&type=script&lang=js"
export * from "./removeAccount.vue?vue&type=script&lang=js"

import "./removeAccount.vue?vue&type=style&index=0&id=320516d6&scoped=true&lang=css"

import exportComponent from "F:\\قبل النهائي\\nawaf\\nawaf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320516d6"]])

export default __exports__